import { Alert, Button, Col, Form, Row } from 'react-bootstrap'
import { StyledTurnIn, StyledTurnInTitle, StyledTurnIns } from './GroundingTurnIn.styled'
import { HTMLText } from 'components/Share/HtmlText'
import { SignatureBox } from '../../components/Grounding/SignatureBox'
import { DropDownData, DropDownGroup, GroundingConfigurationSignatureType } from '../../types/Grounding/GroundingResult'
import DividerWidthText from 'components/Grounding/DividerWidthText'
import GroundingVehicleDetails from 'components/Grounding/GroundingVehicleDetails'
import { useGroundingStore } from './store/useGroundingStore'
import shallow from 'zustand/shallow'
import { useState, useEffect, useMemo } from 'react'
import { DispositionOption } from 'types/Grounding/groundingTypes'
import { DropdownList } from 'layouts/DropdownList'
import { StyledLabelRequired } from './GroundingTurnIn.styled'
import FinalAckModal from 'components/Grounding/FinalAckModal'
import { useGlobalStore } from 'store/useGlobalStore'
import { saveGrounding } from 'apis/groundingApis'
import { GENERAL_ERROR_MESSAGE } from 'common/constants'
import { OverlayLoader } from 'components/Loader'
import { GroundingRenderStep } from './store/RenderStep'
import { useGroundingActionStore } from './store/useGroundingActionStore'

interface IProps {
  setShowCancelModal: (data: boolean) => void
}

export const GroundingTurnIn = ({ setShowCancelModal }: IProps) => {
  const [groundingData, setGroundingData, defaultGroundingData, setShowTerms] = useGroundingStore(
    (state) => [state.groundingData, state.setGroundingData, state.defaultGroundingData, state.setShowTerms],
    shallow
  )
  const [activeStep, setActiveStep, setIsBack] = useGroundingActionStore(
    (state) => [state.activeStep, state.setActiveStep, state.setIsBack],
    shallow
  )

  const [getSystemSettings] = useGlobalStore((state) => [state.getSystemSetting])
  const receivingDealershipPhoneVisibility =
    Number(getSystemSettings('DISPLAY_RECEIVING_DEALERSHIP_PHONE_SECTION')) ?? 0
  const [attributes, setAttributes] = useState<DropDownGroup[]>([])
  const [signatures, setSignatures] = useState<GroundingConfigurationSignatureType[]>(groundingData?.signatureTypes)
  const [paymentTypes, setPaymentTypes] = useState<DropDownData[]>([])

  const [selectedNoSignReason, setSelectedNoSignReason] = useState<number>(groundingData?.selectedNoSignReason)
  const [isSubmit, setIsSubmit] = useState(false)
  const [showFinalAckModal, setShowFinalAckModal] = useState(false)

  const [selectedAcknowledgements, setSelectedAcknowledgements] = useState<number[]>([])
  const [selectedPaymentType, setSelectedPaymentType] = useState<number>(groundingData?.selectedPayment)
  const [isLoading, setIsLoading] = useState(false)
  const [selectedNoSignReasonErrorMessage, setSelectedNoSignReasonErrorMessage] = useState('')
  const [showErrorMessage, setShowErrorMessage] = useState(false)

  const allowPaymentOption = useMemo(() => {
    return (
      (groundingData?.groundingDispositionSelected.ID === DispositionOption.DEALER_INVENTORY_PURCHASE ||
        groundingData?.groundingDispositionSelected.ID === DispositionOption.LESSEE_PURCHASE ||
        groundingData?.groundingDispositionSelected.ID ===
          DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT) &&
      groundingData?.purchasePriceString !== undefined &&
      groundingData?.performPurchase
    )
  }, [groundingData])

  useEffect(() => {
    if (groundingData?.paymentTypes.length > 0 && allowPaymentOption) {
      setSelectedPaymentType(groundingData?.paymentTypes[0]?.ID)
    }
    const link = document.getElementById('termsLink')
    if (link) {
      link.addEventListener('click', handleClick)
    }

    return () => {
      if (link) {
        link.removeEventListener('click', handleClick)
      }
    }
  }, [])

  const handleClick = (event) => {
    event.preventDefault() // Prevent default navigation
    setShowTerms(true)
  }

  useEffect(() => {
    const atts = groundingData?.attributes
    setAttributes(atts)

    setPaymentTypes(groundingData?.paymentTypes)

    groundingData?.signatureTypes.forEach((signatureType) => {
      if (signatureType.SignatureType.toLowerCase() === 'lessee') {
        if (signatureType.SelectedNoSignReason === 0) {
          setSelectedNoSignReasonErrorMessage(GENERAL_ERROR_MESSAGE)
        } else {
          setSelectedNoSignReasonErrorMessage('')
        }
      }
    })
  }, [groundingData, selectedNoSignReason])

  const FormatPhoneNumber = function (phone: string) {
    var numbers = phone.replace(/\D/g, ''),
      char = { 0: '(', 3: ') ', 6: '-' }
    phone = ''
    for (var i = 0; i < numbers.length; i++) {
      phone += (char[i] || '') + numbers[i]
    }
    return phone
  }

  const handleCheckboxChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const { checked, value } = event.target
    setSelectedAcknowledgements((prevSelectedAcknowledgements) => {
      if (checked) {
        return [...prevSelectedAcknowledgements, Number(value)]
      } else {
        return prevSelectedAcknowledgements.filter((acknowledgement) => acknowledgement !== Number(value))
      }
    })
  }

  const handleNoSignReasonChange = (id: number, signIndex: number) => {
    setSelectedNoSignReason(id)
    let signatureTypes = [...signatures]
    signatureTypes[signIndex].SelectedNoSignReason = id
    let newData = { ...groundingData }
    newData.signatureTypes = signatureTypes
    newData.selectedNoSignReason = id
    setGroundingData(newData)
    setSignatures((prevSignatures) => {
      return prevSignatures.map((signature) => {
        if (signature.ID === id) {
          return { ...signature, selectedNoSignReason: id }
        }
        return signature
      })
    })
  }

  const handlePaymentTypeChange = (id: number) => {
    setSelectedPaymentType(id)
    let newData = { ...groundingData, selectedPayment: id }
    setGroundingData(newData)
  }

  const checkNotSelectAllAcknowledgements = () => {
    if (
      (groundingData?.selectedDisposition === DispositionOption.LESSEE_PURCHASE ||
        groundingData?.selectedDisposition === DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT) &&
      selectedAcknowledgements.length !==
        groundingData?.acknowledgements.filter((x) =>
          x.DispositionTypeID.split(',').find((x) => x === groundingData?.selectedDisposition.toString())
        ).length
    ) {
      return true
    }
    return false
  }

  const handleValidationBeforeSubmit = () => {
    setIsSubmit(true)
    let isReadySubmit = true

    signatures.forEach((signatureType) => {
      if (signatureType.signatureImage === null || signatureType.signatureImage === '') {
        isReadySubmit = false
      }

      if (signatureType.SignatureType.toLowerCase() === 'lessee') {
        if (
          signatureType.SelectedNoSignReason === 0 ||
          (signatureType.SelectedNoSignReason !== 0 &&
            signatureType.NoSignReasons?.filter(
              (e) => e.DispositionTypeID === groundingData?.groundingDispositionSelected.ID
            ).find((x) => x.ID === signatureType.SelectedNoSignReason) === undefined)
        ) {
          setSelectedNoSignReasonErrorMessage(GENERAL_ERROR_MESSAGE)
          isReadySubmit = false
        } else {
          setSelectedNoSignReasonErrorMessage('')
        }
      }
    })

    if (
      checkNotSelectAllAcknowledgements() ||
      (allowPaymentOption && groundingData?.paymentTypes.length > 0 && groundingData?.selectedPayment === undefined)
    ) {
      isReadySubmit = false
    }

    if (isReadySubmit === false) {
      setShowErrorMessage(true)
      window.scrollTo(0, 0)
      return false
    }

    return true
  }

  const handleFinalSubmit = async () => {
    setShowFinalAckModal(false)
    updateGroundingData()

    try {
      setIsLoading(true)

      let newGroundingData = JSON.parse(JSON.stringify(groundingData))

      const result = await saveGrounding(groundingData)
      if ((result?.ErrorMessage !== '' && result?.ErrorMessage !== undefined) || result?.SavePayoffError) {
        newGroundingData.ErrorMessage = result?.ErrorMessage ?? result?.SavePayoffError
        if (result?.viewGroundingQuickStart == null) newGroundingData.viewGroundingQuickStart = false
        else newGroundingData.viewGroundingQuickStart = result?.viewGroundingQuickStart
      }
      newGroundingData.VehicleDocuments = result?.VehicleDocuments
      if (result?.AllowOffer !== undefined) newGroundingData.AllowOffer = result?.AllowOffer
      if (result?.purchasePriceString === '$0') newGroundingData.purchasePriceString = '$0'
      setGroundingData(newGroundingData)

      setActiveStep(GroundingRenderStep.GRD_RESULT)
    } catch (error) {
      console.log(error)
    } finally {
      setIsLoading(false)
    }
  }

  const updateGroundingData = () => {
    if (groundingData) {
      let newGroundingData = JSON.parse(JSON.stringify(groundingData))
      newGroundingData.selectedPayment = selectedPaymentType
      setGroundingData(newGroundingData)
    }
  }

  const handleDeclineFinalAck = () => {
    defaultGroundingData.purchasePrice = 0
    defaultGroundingData.purchasePriceString = '$0'
    defaultGroundingData.buyerFee = 0
    defaultGroundingData.buyerFeeString = ''
    defaultGroundingData.encryptedPurchasePrice = ''
    window.scrollTo(0, 0)
    setGroundingData(defaultGroundingData)
    //handleDeclineFinalAcknowledgement()
    if (activeStep !== GroundingRenderStep.GRD_TURN_IN) {
      return
    }
    setIsBack(false)
    setActiveStep(GroundingRenderStep.GRD_OPTIONS)
  }

  return (
    <StyledTurnIns>
      {isLoading && <OverlayLoader />}
      <GroundingVehicleDetails />
      <StyledTurnIn>
        <p>Grounding Completion Date: {groundingData?.groundingDate}</p>
        <Row className="mt-5">
          <Col lg={{ span: 4 }} sm={{ span: 8 }}>
            {showErrorMessage && (
              <Alert
                className="col-6 col-lg-8 col-sm-8"
                variant="danger"
                onClose={() => setShowErrorMessage(false)}
                dismissible
              >
                {'Please review errors and resubmit'}
              </Alert>
            )}
          </Col>
        </Row>
        <DividerWidthText title="Turn-in Receipt and Odometer Statement" />
        <Row className="upper-receipt">
          <Col lg="3" md="3">
            <StyledTurnInTitle>
              <span>Date Grounded: </span>
              {groundingData?.groundingDate}
            </StyledTurnInTitle>
          </Col>
          <Col lg="3" md="3">
            <StyledTurnInTitle>
              <span>Date Turned In: </span>
              {new Date(groundingData?.vehicleReturnDate).toLocaleDateString()}
            </StyledTurnInTitle>
          </Col>
          <Col lg="3" md="3">
            <StyledTurnInTitle>
              <span>Odometer Reading: </span>
              {groundingData?.odometerReading}
            </StyledTurnInTitle>
          </Col>
          {attributes?.map((e) => (
            <Col lg="3" md="3">
              <StyledTurnInTitle>
                <span>{e.Description}: </span>
                {e.selectedID?.FieldDescription}
              </StyledTurnInTitle>
            </Col>
          ))}
        </Row>
        <Row>
          <Col lg="3" md="3">
            <StyledTurnInTitle>
              <span>Dealership Name: </span>
              {groundingData?.lessorName}
            </StyledTurnInTitle>
          </Col>
          <Col lg="3" md="3">
            <StyledTurnInTitle>
              <span>Dealership Address: </span>
              {groundingData?.initLocations?.map((x) => (
                <>
                  {x.ID === groundingData?.selectedAddress && (
                    <>
                      {[x?.Address1, x?.Address2, x?.City, x?.StateCode]
                        .filter((value) => value !== '' && value !== undefined)
                        .join(', ') +
                        ' ' +
                        x?.Zip}
                    </>
                  )}
                </>
              ))}
            </StyledTurnInTitle>
          </Col>
          {receivingDealershipPhoneVisibility === 1 && (
            <Col lg="3" md="3">
              <StyledTurnInTitle>
                <span>Dealership Phone: </span>
                {FormatPhoneNumber(groundingData?.buyerPhoneNo)}
              </StyledTurnInTitle>
            </Col>
          )}
        </Row>

        <DividerWidthText title="Acknowledgements" />
        <Form>
          <Row>
            {signatures?.map((sign, signIndex) => (
              <>
                {sign.SignatureType !== undefined &&
                  groundingData?.acknowledgements.filter(
                    (x) =>
                      x.SignatureTypeID === sign.SignatureTypeID &&
                      x.DispositionTypeID.split(',').find((e) => e === groundingData?.selectedDisposition.toString())
                  ).length > 0 && (
                    <div className="ack-checkbox">
                      <label htmlFor="">
                        As the {sign.SignatureType}, I agree and acknowledge the below statements
                      </label>
                      <Row className="row-parent row-form-group">
                        <div className="checkbox-form">
                          {groundingData?.acknowledgements
                            ?.filter(
                              (x) =>
                                x.SignatureTypeID === sign.SignatureTypeID &&
                                x.DispositionTypeID.split(',').find(
                                  (e) => e === groundingData?.selectedDisposition.toString()
                                )
                            )
                            .map((e) => (
                              <Form.Check
                                key={e.ID}
                                id={'acknowledgements_' + e.ID.toString()}
                                type="checkbox"
                                className="acknowledgements_cb"
                                label={
                                  <HTMLText
                                    value={e.Description.replace('%AMOUNT%', groundingData?.purchasePriceString)}
                                  />
                                }
                                custom
                                checked={selectedAcknowledgements.includes(e.ID)}
                                onChange={handleCheckboxChange}
                                value={e.ID.toString()}
                              />
                            ))}
                          <p className="error-label">
                            {isSubmit && checkNotSelectAllAcknowledgements() && GENERAL_ERROR_MESSAGE}
                          </p>
                        </div>
                      </Row>
                    </div>
                  )}
              </>
            ))}
          </Row>
          <Row>
            {signatures?.map((sign, signIndex) => (
              <Col className="signature-column col-12 col-xl-5 col-lg-5 offset-lg-1">
                <SignatureBox
                  isSubmit={isSubmit}
                  groundingData={groundingData}
                  title={sign.SignatureType}
                  configText={sign.ConfigDescription}
                  image={sign.signatureImage}
                  index={signIndex}
                  setGroundingData={setGroundingData}
                  canvasHeight={100}
                  signatureTypeId={sign.SignatureTypeID}
                />
              </Col>
            ))}
          </Row>
          <Row>
            {signatures?.map(
              (sign, signIndex) =>
                sign.NoSignReasons &&
                sign.NoSignReasons.length > 0 && (
                  <>
                    <div className="nosign-container">
                      <StyledLabelRequired className={'required-field'}>
                        IF LESSEE DID NOT SIGN, PLEASE SIGN AND INDICATE DEALER SIGNATURE ON LESSEE’S BEHALF:
                      </StyledLabelRequired>
                      <div className="nosign-dropdown">
                        <DropdownList
                          defaultValue={sign.SelectedNoSignReason ? sign.SelectedNoSignReason.toString() : 'Select'}
                          items={sign.NoSignReasons?.filter(
                            (e) => e.DispositionTypeID === groundingData?.groundingDispositionSelected.ID
                          )?.map((item) => ({
                            id: item?.ID?.toString(),
                            value: item?.Description
                          }))}
                          onChange={(id) => handleNoSignReasonChange(Number(id), signIndex)}
                        />
                        <p className="error-label">
                          {isSubmit && !!selectedNoSignReasonErrorMessage && selectedNoSignReasonErrorMessage}
                        </p>
                      </div>
                    </div>
                  </>
                )
            )}
          </Row>

          <Row className="row-parent mb-4">
            <HTMLText value={groundingData?.GroundingNotice} />
          </Row>
          {allowPaymentOption && (
            <>
              <DividerWidthText title="PAYMENT OPTIONS" />
              <Row className="row-parent mt-3">
                <Col lg="3">
                  <Row className="row-child">
                    <Col sm="12" lg="12">
                      <strong>Price: </strong>
                      <span className="price-span">{groundingData?.purchasePriceString}</span>
                    </Col>
                  </Row>
                  <>
                    <Row className="row-child">
                      <Col sm="12" lg="12">
                        <strong>Buyer Fee: </strong>
                        <span className="price-span">{groundingData?.buyerFeeString}</span>
                      </Col>
                    </Row>

                    <Row className="row-child">
                      <Col sm="12" lg="12">
                        <strong>Total Price: </strong>
                        <span className="price-span price-total">
                          {'$' +
                            (groundingData?.purchasePrice + groundingData?.buyerFee)
                              .toString()
                              .replace(/\B(?=(\d{3})+(?!\d))/g, ',')}
                        </span>
                      </Col>
                    </Row>
                  </>
                </Col>
                <Col lg={{ span: 4, offset: 1 }}>
                  <div className="payment-dropdown">
                    <Form.Label>Payment Method</Form.Label>
                    <DropdownList
                      defaultValue={selectedPaymentType !== undefined ? selectedPaymentType.toString() : 'Select'}
                      items={paymentTypes?.map((item) => ({
                        id: item?.ID?.toString(),
                        value: item?.Description
                      }))}
                      onChange={(id) => handlePaymentTypeChange(Number(id))}
                    />
                    <p className="error-label">{isSubmit && selectedPaymentType === 0 && GENERAL_ERROR_MESSAGE}</p>
                  </div>
                </Col>
              </Row>
            </>
          )}

          <DividerWidthText title={null} />
          <Row className="row-parent btn-row">
            <Button variant="link" onClick={() => setShowCancelModal(true)}>
              CANCEL
            </Button>
            <Button
              className="btn-secondary mr-3"
              onClick={() => {
                setIsBack(true)
                setActiveStep(GroundingRenderStep.GRD_OPTIONS)
              }}
            >
              Back
            </Button>
            {(groundingData?.purchasePriceString === undefined ||
              groundingData?.purchasePriceString === null ||
              groundingData?.purchasePriceString === '' ||
              !groundingData?.performPurchase) && (
              <Button
                variant="primary"
                onClick={() => {
                  if (handleValidationBeforeSubmit()) {
                    handleFinalSubmit()
                  }
                }}
              >
                Submit
              </Button>
            )}
            {groundingData?.purchasePriceString !== undefined &&
              groundingData?.purchasePriceString !== null &&
              groundingData?.purchasePriceString !== '' &&
              groundingData?.performPurchase && (
                <Button
                  variant="primary"
                  onClick={() => {
                    if (
                      groundingData?.groundingDispositionSelected.ID === DispositionOption.DEALER_INVENTORY_PURCHASE ||
                      groundingData?.groundingDispositionSelected.ID === DispositionOption.LESSEE_PURCHASE ||
                      groundingData?.groundingDispositionSelected.ID ===
                        DispositionOption.DEALER_INVENTORY_PURCHASE_WITH_NEW_NMAC_CONTRACT
                    ) {
                      if (handleValidationBeforeSubmit()) {
                        setShowFinalAckModal(true)
                      }
                    } else {
                      if (handleValidationBeforeSubmit()) {
                        handleFinalSubmit()
                      }
                    }
                  }}
                >
                  Submit &amp; Buy
                </Button>
              )}
          </Row>
        </Form>
        <FinalAckModal
          show={showFinalAckModal}
          onClose={() => {
            handleDeclineFinalAck()
            setShowFinalAckModal(false)
          }}
          events={{
            handleAcknowledgedConfirm: handleFinalSubmit,
            setShowModal: setShowFinalAckModal
          }}
        ></FinalAckModal>
      </StyledTurnIn>
    </StyledTurnIns>
  )
}

export default GroundingTurnIn
